/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Api_Errors_Geldigheid_OngeldigInputs */

const nl_planning_api_errors_geldigheid_ongeldig = /** @type {(inputs: Planning_Api_Errors_Geldigheid_OngeldigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De einddatum ligt voor de begindatum.`)
};

/**

* @param {Planning_Api_Errors_Geldigheid_OngeldigInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_api_errors_geldigheid_ongeldig = /** @type {((inputs?: Planning_Api_Errors_Geldigheid_OngeldigInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Api_Errors_Geldigheid_OngeldigInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_api_errors_geldigheid_ongeldig(inputs)
});
export { planning_api_errors_geldigheid_ongeldig as "planning.api_errors.geldigheid_ongeldig" }